// Dependencies
import styled from 'styled-components';

const BlogPostFlexibleContentStyles = styled.div`
  width: 100%;
  margin: 0 0 3rem 0;

  .article-body {
    max-width: 60rem;
    margin: 0 auto;
  }

  .flexible-content-layout {
    margin-bottom: 2rem;

    &:first-child {
      p:first-of-type:first-letter {
        float: left;
        margin-top: 1.5rem;
        padding-right: 0.3rem;
        font-family: Serif;
        font-size: 70px;
        line-height: 1.3rem;
      }
    }
  }

  @media (min-width: 768px) {
    width: 70%;
    margin: 1.25rem 0 1.5rem 0;
    padding: 0 10% 0 0;
  }

  @media (min-width: 992px) {
    width: 80%;
  }

  @media (min-width: 1200px) {
    padding: 0 20% 0 0;
  }
`;

export default BlogPostFlexibleContentStyles;
